class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.panel = this.querySelector('.cart-drawer__panel');
    this.body = this.querySelector('[data-cart-body]');
    this.countEl = this.querySelector('[data-cart-count]');
    this.totalEl = this.querySelector('[data-cart-total]');
    this.shippingBar = this.querySelector('[data-shipping-bar]');
    this.focusTrap = null;
    this.previousFocus = null;
  }

  connectedCallback() {
    // Delegated so close buttons re-rendered by an AJAX refresh keep working.
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) this.close();
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });

    this.panel?.addEventListener('click', (e) => {
      const action = e.target.closest('[data-action]');
      if (!action) return;

      const key = action.dataset.key;
      const type = action.dataset.action;

      if (type === 'remove') {
        this.updateQuantity(key, 0);
      } else if (type === 'increase') {
        const item = action.closest('.cart-drawer__item');
        const qty = parseInt(item.querySelector('[data-quantity]').textContent);
        this.updateQuantity(key, qty + 1);
      } else if (type === 'decrease') {
        const item = action.closest('.cart-drawer__item');
        const qty = parseInt(item.querySelector('[data-quantity]').textContent);
        this.updateQuantity(key, Math.max(0, qty - 1));
      }
    });

    document.addEventListener('cart:add', () => {
      this.refresh().then(() => this.open());
    });

    document.querySelectorAll('[data-cart-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
  }

  open() {
    this.previousFocus = document.activeElement;
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    this.trapFocus();
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    this.previousFocus?.focus();
  }

  trapFocus() {
    requestAnimationFrame(() => {
      const closeBtn = this.querySelector('.cart-drawer__close');
      closeBtn?.focus();
    });
  }

  async updateQuantity(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      if (!response.ok) throw new Error('Update failed');

      await this.refresh();
    } catch (error) {
      console.error('Cart update error:', error);
    }
  }

  async refresh() {
    try {
      const response = await fetch('/?sections=cart-drawer-content');
      const data = await response.json();

      if (data['cart-drawer-content']) {
        const temp = document.createElement('div');
        temp.innerHTML = data['cart-drawer-content'];
        // Re-render the entire panel so body, shipping bar, and footer
        // (subtotal + checkout) stay in sync. Critical when the cart goes from
        // empty to non-empty: the footer must be newly inserted, not just patched.
        const newPanel = temp.querySelector('.cart-drawer__panel');
        if (newPanel && this.panel) {
          this.panel.innerHTML = newPanel.innerHTML;
        }
      }

      // Also update the header cart count badge
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.closest('.header__cart-badge')?.classList.toggle('is-hidden', cart.item_count === 0);
      });

    } catch (error) {
      console.error('Cart refresh error:', error);
      // Fallback: reload the page section
      window.location.reload();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
